// source: protocol_conference.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var header_entity_pb = require('./header_entity_pb.js');
goog.object.extend(proto, header_entity_pb);
goog.exportSymbol('proto.himpb.ConfRoleRequestNty', null, global);
goog.exportSymbol('proto.himpb.ConfRoleRequestReply', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.ConfRoleRequestNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.ConfRoleRequestNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.ConfRoleRequestNty.displayName = 'proto.himpb.ConfRoleRequestNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.ConfRoleRequestReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.ConfRoleRequestReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.ConfRoleRequestReply.displayName = 'proto.himpb.ConfRoleRequestReply';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.ConfRoleRequestNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.ConfRoleRequestNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.ConfRoleRequestNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.ConfRoleRequestNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    confid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    hostid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    requserid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    role: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.ConfRoleRequestNty}
 */
proto.himpb.ConfRoleRequestNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.ConfRoleRequestNty;
  return proto.himpb.ConfRoleRequestNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.ConfRoleRequestNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.ConfRoleRequestNty}
 */
proto.himpb.ConfRoleRequestNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHostid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequserid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.ConfRoleRequestNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.ConfRoleRequestNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.ConfRoleRequestNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.ConfRoleRequestNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getConfid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHostid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRequserid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRole();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.ConfRoleRequestNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.ConfRoleRequestNty} returns this
*/
proto.himpb.ConfRoleRequestNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.ConfRoleRequestNty} returns this
 */
proto.himpb.ConfRoleRequestNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.ConfRoleRequestNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string confId = 2;
 * @return {string}
 */
proto.himpb.ConfRoleRequestNty.prototype.getConfid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.ConfRoleRequestNty} returns this
 */
proto.himpb.ConfRoleRequestNty.prototype.setConfid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string hostId = 3;
 * @return {string}
 */
proto.himpb.ConfRoleRequestNty.prototype.getHostid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.ConfRoleRequestNty} returns this
 */
proto.himpb.ConfRoleRequestNty.prototype.setHostid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string reqUserId = 4;
 * @return {string}
 */
proto.himpb.ConfRoleRequestNty.prototype.getRequserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.ConfRoleRequestNty} returns this
 */
proto.himpb.ConfRoleRequestNty.prototype.setRequserid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 role = 5;
 * @return {number}
 */
proto.himpb.ConfRoleRequestNty.prototype.getRole = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.ConfRoleRequestNty} returns this
 */
proto.himpb.ConfRoleRequestNty.prototype.setRole = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.ConfRoleRequestReply.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.ConfRoleRequestReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.ConfRoleRequestReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.ConfRoleRequestReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    confid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    requserid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    isallow: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    role: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.ConfRoleRequestReply}
 */
proto.himpb.ConfRoleRequestReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.ConfRoleRequestReply;
  return proto.himpb.ConfRoleRequestReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.ConfRoleRequestReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.ConfRoleRequestReply}
 */
proto.himpb.ConfRoleRequestReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequserid(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsallow(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.ConfRoleRequestReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.ConfRoleRequestReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.ConfRoleRequestReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.ConfRoleRequestReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getConfid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequserid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsallow();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getRole();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.ConfRoleRequestReply.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.ConfRoleRequestReply} returns this
*/
proto.himpb.ConfRoleRequestReply.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.ConfRoleRequestReply} returns this
 */
proto.himpb.ConfRoleRequestReply.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.ConfRoleRequestReply.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string confId = 2;
 * @return {string}
 */
proto.himpb.ConfRoleRequestReply.prototype.getConfid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.ConfRoleRequestReply} returns this
 */
proto.himpb.ConfRoleRequestReply.prototype.setConfid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string reqUserId = 3;
 * @return {string}
 */
proto.himpb.ConfRoleRequestReply.prototype.getRequserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.ConfRoleRequestReply} returns this
 */
proto.himpb.ConfRoleRequestReply.prototype.setRequserid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool isAllow = 4;
 * @return {boolean}
 */
proto.himpb.ConfRoleRequestReply.prototype.getIsallow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.ConfRoleRequestReply} returns this
 */
proto.himpb.ConfRoleRequestReply.prototype.setIsallow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional uint32 role = 5;
 * @return {number}
 */
proto.himpb.ConfRoleRequestReply.prototype.getRole = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.ConfRoleRequestReply} returns this
 */
proto.himpb.ConfRoleRequestReply.prototype.setRole = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


goog.object.extend(exports, proto.himpb);
